import { Customer, ConsignmentAddtionalDetails, ConsignmentPallets, ConsignmentPackages, Consignment, AdditionalDrop } from 'src/@core/models';
import { Time } from '@angular/common';

export class IConsignmentEdit {
    id: string;
    customerID: string;
    serviceConsignments: number;
    date: Date;
    time: Time;
    premisesOpenUntil: Time;
    customerContact: string;
    customerEmail: string;
    poNumber: string;
    pickupLocation: string;
    consignmentType: number;

    collectionAddressID?: string;
    collectionPostCode?: string;
    collectionAddress1?: string;
    collectionAddress2?: string;
    collectionAddress3?: string;
    collectionTown?: string;
    collectionCounty?: string;
    collectionCountry?: string;
    collectionCompanyName?: string;
    collectionContactName?: string;
    collectionContactNumber?: string;
    collectionHouseNumber?: string;

    deliveryAddressID?: string;
    deliveryPostCode?: string;
    deliveryAddress1?: string;
    deliveryAddress2?: string;
    deliveryAddress3?: string;
    deliveryTown?: string;
    deliveryCounty?: string;
    deliveryTime?: string;
    deliveryCompanyName?: string;
    deliveryContactName?: string;
    deliveryContactNumber?: string;
    deliveryHouseNumber?: string;
    deliveryCountry?: string;
    deliveryFrom?: Time;
    deliveryTo?: Time;
    asap: boolean;

    serviceLevelConsignment: number;

    vehicleTypeID: string;
    insuranceTypes: number;
    trackingNeeded: boolean;
    tailLift: boolean;
    specialInstructions: string;
    goodDescription: string;
    transportService: number;
    goodsValue: number;
    check1: boolean;
    check2: boolean;
    check3: boolean;
    check4: boolean;
    check5: boolean;
    customerNotes: string;
    baseCustomerPrice: number;
    baseCostPrice: number;
    baseCustomerPriceManual: boolean;
    baseCustomerPriceOverrideReason: string;
    baseCostPriceManual: boolean;
    baseCostPriceOverrideReason: string;
    statusConsignment: number;
    consignmentPackages: Array<ConsignmentPackages>;
    consignmentPallets: Array<ConsignmentPallets>;

    consignmentAddtionalDetails: Array<ConsignmentAddtionalDetails>;
    AdditionalDrops: Array<AdditionalDrop>;
    consignmentNotes: Array<any>;
    totalWeight: number;
    checkWeight: number;
    subcontractorName: string;
    consignmentIDNumber: number;
    vehicleTypeName: string;
    customer: Customer;
    jobType: any;
    quantityUnknown?: boolean;
    subcontractorHxID: string;
    subcontractorID: string;
    supplierID: string;

    estimatedMileage?: number;
    haulageExchangeId?: string;
    postToHx?: boolean;
    externalId?: string;
    totalCustomerPrice?: number;
    totalConsignmentPrice?: number;
    totalAddChargesCost?: number;
  totalAddChargesPrice?: number;
  companyName: string;
}
